module.exports = __webpack_public_path__ + "img/FR17338.cd46b27d.png";